import React from 'react';
import { ServiceDetailPage } from '../../components/ServiceLayout/ServiceDetailPage';
import freightImg from '../../images/offers-freight.jpg';

export const FreightPage = () => (
  <ServiceDetailPage
    meta={{
      title: 'Freight Transportation — Renuit Logistics',
      description: 'Reliable FTL and LTL freight across Southeast, Gulf Coast, and East Coast lanes. Vetted carriers, real-time tracking, proactive communication.',
      canonical: 'https://www.renuit.pro/services/freight-transportation',
    }}
    hero={{
      image: freightImg,
      tag: 'Most Requested',
      heading: 'Freight Transportation',
      subheading: 'FTL and LTL moves across Southeast, Gulf Coast, and East Coast corridors. Consistent execution with total visibility — not just a tracking number.',
    }}
    detail={{
      heading: 'Full Coverage, Zero Surprises',
      subheading: 'Whether you move a partial pallet or a fleet of truckloads weekly, we build your freight program around your volume, lanes, and delivery windows.',
      features: [
        'Full truckload (FTL) and Less-than-truckload (LTL)',
        'Temperature-controlled and refrigerated capacity',
        'Hazmat-certified carrier options available',
        'Real-time GPS tracking with milestone alerts',
        'Vetted, FMCSA-compliant carrier network',
        'Dedicated account manager on every shipment',
        'POD documentation within 24h of delivery',
      ],
      image: freightImg,
    }}
    steps={[
      { n: '01', title: 'Submit load details', body: 'Provide your lane, weight, commodity type, and pickup window. Takes under 5 minutes.' },
      { n: '02', title: 'Receive a rate within 4 hours', body: 'We quote with carrier details included — no mystery brokers.' },
      { n: '03', title: 'We manage the move', body: 'Your account manager coordinates pickup, monitors transit, and alerts you to any delays before they become problems.' },
      { n: '04', title: 'Delivery confirmation', body: 'POD documentation delivered within 24h. Clean records for every shipment.' },
    ]}
    faq={[
      { q: 'Do you handle hazardous materials?', a: 'Yes. We have hazmat-certified carriers for most hazard classes. Provide the UN number and hazard class at quote time so we can match the right carrier.' },
      { q: 'What is the LTL minimum shipment size?', a: 'Most LTL carriers require a minimum of 150 lbs. For lighter loads, we can advise whether parcel pricing is more cost-effective.' },
      { q: 'Do I get real-time tracking?', a: 'All FTL shipments include GPS tracking and milestone alerts. LTL status depends on carrier, but we check proactively and relay updates to you.' },
      { q: 'What happens if there is a delay?', a: 'Your account manager notifies you before your deadline is affected — not after. We communicate cause, severity, and revised ETA in real time.' },
    ]}
    cta={{
      heading: 'Ready to Move Freight?',
      subheading: 'Get a rate within 4 business hours. No commitment required.',
      primaryText: 'Request a Freight Quote',
      primaryTo: '/quote',
      phone: '(786) 628-3731',
    }}
  />
);
